/******/ (() => { // webpackBootstrap
var __webpack_exports__ = {};
Shopify.theme.jsSidebar = {
  init: function() {

    const facetedFilterForm = document.querySelector('[data-faceted-filter-form]')
    if (facetedFilterForm) {
      facetedFilterForm.addEventListener('change', e => {
        if (e.target.type == 'number') return;
        facetedFilterForm.submit();
      });
    }
    
    $('[data-sidebar-mobile-toggle]').on('click',this.openDrawer.bind(this))
    $('[data-sidebar-mobile-close]').on('click',this.closeDrawer.bind(this))

    const openSidebarBlocks = document.querySelectorAll('[data-sidebar-block__toggle="open"]');

    openSidebarBlocks.forEach(function(block){
      Shopify.theme.jsSidebar.openSidebarBlock($(block));
    })


    $('[data-has-toggle-option]').on('click', '[data-sidebar-block__toggle="closed"]', function (e) {
      e.preventDefault();
      Shopify.theme.jsSidebar.openSidebarBlock($(this));
    });
    $('[data-has-toggle-option]').on('click', '[data-sidebar-block__toggle="open"]', function(e) {
      e.preventDefault();
      Shopify.theme.jsSidebar.closeSidebarBlock($(this));
    });

    if ($('[data-product-sidebar]').length) {
      $('.section--has-sidebar-option').addClass('has-sidebar-enabled');
      $('.section--has-sidebar-option').removeClass('has-sidebar-disabled');
    } else {
      $('.section--has-sidebar-option').removeClass('has-sidebar-enabled');
      $('.section--has-sidebar-option').addClass('has-sidebar-disabled');

    }

  },
  openSidebarBlock: function ($toggleBtn) {
    const $parent = $toggleBtn.closest('[data-has-toggle-option]');
    const $toggleIcon = $toggleBtn.find('.icon');

    $toggleBtn.attr('data-sidebar-block__toggle', 'open');

    $parent.attr('aria-expanded', true);
    $parent.siblings('[data-sidebar-block__content--collapsible]').slideDown();
  },
  openDrawer: function(e){
    e.preventDefault()
    let $ele = $(e.target)
    let id = $ele.data('sidebar-mobile-toggle')
    window.scrollTo(0,0)
    $(`[data-sidebar-mobile-drawer="${id}"]`).addClass('is-active')  
    let headersHeight = parseInt($('#mobile-header').outerHeight()) + parseInt($('#announcement-bar-with-slider').outerHeight())
    $(`[data-sidebar-mobile-drawer="${id}"]`).css('max-height',`calc(100% - ${headersHeight}px)`)        
    $('body').addClass('mobile-menu--opened')
     if ($(`[data-sidebar-mobile-drawer="${id}"]`).hasClass('CollectionFilterSidebar')) {
        //$(`[data-sidebar-mobile-drawer="${id}"]`).css('top', `${headersHeight}px`)
       $(`[data-sidebar-mobile-drawer="${id}"]`)[0].style.setProperty('top', `${headersHeight}px`, 'important');
    }
  },
  closeDrawer: function(e){
    console.log(e.target)
    e.preventDefault()
    let $ele = $(e.target)
    let id = $ele.data('sidebar-mobile-close')
    $(`[data-sidebar-mobile-drawer="${id}"]`).removeClass('is-active')
    $('body').removeClass('mobile-menu--opened')
  },
  closeSidebarBlock: function ($toggleBtn) {

    const $parentBlock = $toggleBtn.closest('[data-has-toggle-option]');
    const $toggleIcon = $toggleBtn.find('.icon');

    $toggleBtn.attr('data-sidebar-block__toggle', 'closed');

    $parentBlock.attr('aria-expanded', false);
    $parentBlock.siblings('[data-sidebar-block__content--collapsible]').slideUp();
  },
  unload: function() {
    const $toggleBtn = $('[data-sidebar-block__toggle]');
    $toggleBtn.off();
  }
}

/******/ })()
;